import { Reveal } from "./Reveal";

const POINTS = [
    {
        title: "Convert USDT to INR at live rates",
        text: "The USDT to INR rate shown on this page comes from the same live source as DtOrbit, so you always see the current value before you convert USDT to INR — no guesswork and no stale numbers.",
    },
    {
        title: "Sell USDT for INR with a simple flow",
        text: "To sell USDT for INR, start your exchange on DtOrbit, enter your exchange and payout details, and send USDT through the supported network, such as TRC20. Once your transaction is checked and processed, INR is sent according to the exchange process.",
    },
    {
        title: "Secure processing you can verify",
        text: "Every USDT to INR conversion is handled with authenticated processing in mind. For your safety, always make sure you are on the official dtorbit.com website before starting an exchange.",
    },
];

export default function SeoContent() {
    return (
        <section
            id="about"
            data-testid="seo-content-section"
            className="relative py-16 md:py-24 border-t border-[#E4EAF6]"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6">
                <article>
                    <Reveal>
                        <div className="max-w-3xl">
                            <span className="text-xs uppercase tracking-[0.25em] text-[#1E56FF] font-bold">
                                USDT to INR Exchange
                            </span>
                            <h2 className="font-display mt-3 text-3xl md:text-4xl font-bold tracking-tight text-[#0F1B3D]">
                                Fast &amp; Secure USDT to INR Exchange
                            </h2>
                            <p className="mt-5 text-sm md:text-base text-[#5B6B8C] leading-relaxed">
                                USDT to INR exchange means converting your Tether
                                (USDT) — a US dollar-pegged stablecoin — into
                                Indian Rupees. DtOrbit is a USDT to INR exchange
                                platform built to make that conversion simple:
                                check the live USDT to INR rate, send your USDT,
                                and receive INR through the payout details you
                                provide.
                            </p>
                        </div>
                    </Reveal>

                    <div className="mt-10 md:mt-12 grid md:grid-cols-3 gap-8 md:gap-10">
                        {POINTS.map((point, i) => (
                            <Reveal key={point.title} delay={i * 100}>
                                <div data-testid={`seo-point-${i + 1}`}>
                                    <h3 className="font-display text-base font-bold text-[#0F1B3D]">
                                        {point.title}
                                    </h3>
                                    <p className="mt-2.5 text-sm text-[#5B6B8C] leading-relaxed">
                                        {point.text}
                                    </p>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </article>
            </div>
        </section>
    );
}
